
import $ from 'jquery';
import {showError,hideError} from './../general/Error.js';


const testPlzRegex = /^\d+$/;

class PostNumValidator {

	constructor( element ) {

		this.$input  = $( element );
		this.$form   = this.$input.closest( 'form' );
		this.$select = this.$form.find( '.countryTxt_pp' );

		this.$form.on( 'input validatelement.acl', '.acl_input--plz', () => this.validate() );
		this.$form.on( 'change', '.acl_input--country', () => this.update() );
	};

	update = () => {

		const zipLength = this.$select.find( 'option:selected' ).data( 'zip-length' );

		if ( zipLength ) {
			this.$input.attr( 'maxlength', zipLength );
		} else {
			this.$input.removeAttr( 'maxlength' );
		}

		return this.validate();
	};

	validate = () => {

		const inputEl = this.$input.get(0);
		const isValid = this.isValid();

		if ( isValid ) {
			this.setCustomValidity( '' );
		}  else {
			this.setCustomValidity( 'Die von Ihnen eingegebene PLZ ist ungültig. Bitte überprüfen Sie Ihre Eingabe und korrigieren Sie diese.' );
		}

		return isValid;
	};

	isValid = () => {

		const inputVal  = this.$input.val();
		const zipLength = this.$select.find( 'option:selected' ).data( 'zip-length' );

		if ( ! zipLength ) {
			return true;
		}

		return parseInt( zipLength ) === inputVal.length && testPlzRegex.test( inputVal );
	};

	setCustomValidity = ( validity ) => {
		const inputEl = this.$input.get(0);
		inputEl.setCustomValidity( validity );
		inputEl.checkValidity();
		inputEl.dispatchEvent( new CustomEvent( 'validated.acl', { bubbles: true } ) );
	};

	static checkPostNumLength = ( element ) => {

		const $el = $( element );

		if ( $el.data( 'postNumValidator' ) ) {
			return $el.data( 'postNumValidator' ).isValid();
		}

		const $input = $el.find( 'input[data-validate="checkPostNumLength"]' );

		if ( $input.length > 0 ) {
			return PostNumValidator.checkPostNumLength( $input );
		}

		return true;
	};
}


$( document ).ready( function() {

	const $inputs = $( 'input[data-validate="checkPostNumLength"]' );
	$inputs.each( function() {

		const instance = new PostNumValidator( this );
		$( this ).data( 'postNumValidator', instance );
	} );
} );

window.checkPostNumLength = PostNumValidator.checkPostNumLength;

export default PostNumValidator;
